import { ApiModule } from '@core';
import type { HtmlContent } from '../models/html-content.model';

export class HtmlContentApi extends ApiModule {
  public loadContent(key: string, lang: string) {
    return this.api.get<HtmlContent>(`/tech/htmlblock/${key}/${lang}`);
  }
}
